import { useMemo } from 'react';

import { useAuth } from '../../global/contexts/auth/auth';
import ParceriasSummary from '../../features/parcerias/layouts/summary';
import CowhousingSummary from '../../features/vacas/layouts/summary';

import '../styles/home.css';

// TSS vite/01 — thin page. The client landing: composes the per-role summaries
// (parcerías + cowhousing) from their features and gates each by the client's
// `roles_with_data`. A page is the ONLY layer allowed to compose across
// features (TSS 01 §"Layer communication rules" — features/<a> → features/<b>
// is forbidden), and a page may read useAuth to gate (TSS 01 §import rules).
//
// Gating here is by DATA-ROLE (which roles have backing records), not by
// permission grants — every client shares the same `public:*` grant, so
// can()/<Gate> can't tell partner from donor_owner. This mirrors visibleNav()
// and the "el front oculta lo que no tiene datos" contract rule. Mounting a
// summary conditionally also keeps its query from firing for absent roles.

export default function HomePage() {
    const { user } = useAuth();

    const roles = useMemo(
        () => new Set(Array.isArray(user?.roles_with_data) ? user.roles_with_data : []),
        [user],
    );

    const showParcerias = roles.has('partner');
    const showCowhousing = roles.has('donor_owner');
    const hasSections = showParcerias || showCowhousing;

    return (
        <div className="home">
            <header className="home__greeting">
                <h1 className="home__hello">Hola{user?.name ? `, ${user.name}` : ''}</h1>
                <p className="home__subtitle">Este es el resumen de tu portal.</p>
            </header>

            {hasSections ? (
                <div className="home__grid">
                    {showParcerias && <ParceriasSummary />}
                    {showCowhousing && <CowhousingSummary />}
                </div>
            ) : (
                <p className="home__empty">
                    Aún no hay información asociada a tu cuenta. Si crees que es un error,
                    comunícate con Agropecuaria Los Manantiales.
                </p>
            )}
        </div>
    );
}
